import { Component, OnInit } from '@angular/core';
import { RewardsService } from './rewardservice/rewards.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from '../Services/cookie'
import { DatePipe, Location } from "@angular/common";
import { Subject } from "rxjs";
import { factory } from 'typescript';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-loyalty-points',
  templateUrl: './loyalty-points.component.html',
  standalone:false,
  styleUrls: ['./loyalty-points.component.scss']
})
export class LoyaltyPointsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  LoyaltyCards;
  PointHistory;
  selectedPointHistory;
  selectedLoyaltyCards;
  MonthwiseData;
  groupedData = {};
  uniqueMonths
  HistoryData;
  Redmp: boolean = true;
  activeTab: number;
  selectevent: any;
  Date: Date = new Date()
  CurrentYear: number;
  lastday: any;
  Months: any[] = [{ Mon: "Jan", Num: 1 }, { Mon: "Feb", Num: 2 }, { Mon: "Mar", Num: 3 }, { Mon: "APR", Num: 4 }, { Mon: "May", Num: 5 }, { Mon: "Jun", Num: 6 }, { Mon: "Jul", Num: 7 }, { Mon: "Aug", Num: 8 }, { Mon: "Sep", Num: 9 }, { Mon: "Oct", Num: 10 }, { Mon: "Nov", Num: 11 }, { Mon: "Dec", Num: 12 }]
  selectedMonth: any[];
  maxSliderValues: any;
  shukranNumber: any;
  // Points Calculator
  calcLocalSpend: number = 0;
  calcIntlSpend: number = 0;
  calcGovPetrol: number = 0;
  calcEurGbp: number = 0;
  selectedCalcCardInternalId: string = '';
  calcResult: any = null;
  RedeemTypeList: any[] = [];
  gulfAirFFPnumber: any;

  // Category filter chips
  selectedCategory: string = 'all';
  rewardCategories: any[] = [{ id: 'all', label: 'All', icon: '', partnerCode: '' }];
  redeemMasterList: any[] = [];

  carouselOptions: OwlOptions = {
    loop: false,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };



  constructor(private reward: RewardsService, public auth: AuthService, private CommonServices: CommonService, public router: Router, public cookieService: CookieService, private datepipe: DatePipe, private spinner: NgxSpinnerService) {
    // Listen to navigation events - re-trigger loader when navigating to this page
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // Match exact paths only. The previous `includes('/LoyaltyPoints')` check
      // accidentally matched /LoyaltyPointsRadeem, /LoyaltyPointsRadeemConfirm,
      // and /LoyaltyPointsRadeemSucces as well — firing loadData() in parallel
      // with those pages' ngOnInit, causing concurrent VerifyToken + GetRedeemMaster
      // bursts that the server intermittently rejects with 401 "Unable to decrypt
      // aes key".
      const url = (event.urlAfterRedirects || '').split('?')[0];
      if (url === '/LoyaltyPoints' || url === '/LoyaltyPoints/') {
        // Force the spinner to show on every navigation to this page (including from dashboard)
        this.spinner.show();
        setTimeout(() => this.loadData(), 50);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    // First-time component load — also trigger loader
    this.spinner.show();
    setTimeout(() => this.loadData(), 50);
  }

  // Guard against the navigation listener and ngOnInit firing loadData() twice
  // (both run setTimeout(loadData, 50) on every navigation to /LoyaltyPoints,
  // producing concurrent VerifyToken + GetRedeemMaster chains that race the
  // server's encryption layer).
  private loadDataInFlight = false;
  private loadDataCompleted = false;

  private async loadData(): Promise<void> {
    // Deduplicate concurrent loadData() calls. The navigation listener and
    // ngOnInit both schedule this via setTimeout(50); without this guard,
    // both chains would race the server's encryption layer on token validation.
    if (this.loadDataInFlight) {
      console.log('[LoyaltyPoints] loadData skipped (in flight)');
      return;
    }
    this.loadDataInFlight = true;
    this.loadDataCompleted = false;

    this.cookieService.set("maxSlider",'',true);
    this.cookieService.set('shukranNumber2', '',true);
    this.cookieService.set('gulfAirFFPnumber','',true);

    this.uniqueMonths = [];
    this.groupedData = {};
    this.spinner.show();
    await this.CommonServices.presentLoading();
    this.auth.accessToken = await this.CommonServices.Get("token");
    this.CurrentYear = this.Date.getFullYear();
    console.log("CurrentYear", this.CurrentYear)

    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
        this.reward.GetRewardsSummary(this.auth.accessToken).then(async (data: any) => {

          if (data?.response?.code == 1) {
            // New API structure: data.response.rewardSummary (array)
            let rewardSummary = data.response.rewardSummary || data.response.content || [];
            this.LoyaltyCards = rewardSummary.sort(((x: any, y: any) => {
              return (Number(x.rewardsBalance) < Number(y.rewardsBalance)) ? 1 : (Number(x.rewardsBalance) > Number(y.rewardsBalance)) ? -1 : 0
            }))

            this.selectedLoyaltyCards = this.LoyaltyCards[0];
            this.reward.LoyaltyCard = this.selectedLoyaltyCards;

            this.cookieService.set('LoyaltyCard',JSON.stringify(this.selectedLoyaltyCards),true);

            // Extract partner accounts from new API structure
            let partnerAccounts = this.selectedLoyaltyCards?.partnerAccounts || [];
            let shukranAccount = partnerAccounts.find((p: any) => p.partnerCode === 'SHUKRAN');
            let gulfAirAccount = partnerAccounts.find((p: any) => p.partnerCode === 'GULF_AIR_FFP');

            this.shukranNumber = shukranAccount?.accountNumber || '';
            this.gulfAirFFPnumber = gulfAirAccount?.accountNumber || '';

            this.cookieService.set('Shukrano', this.shukranNumber, true);
            this.cookieService.set('GUlfairNo', this.gulfAirFFPnumber, true);
            this.cookieService.set('shukranNumber2', this.shukranNumber, true);
            this.cookieService.set('gulfAirFFPnumber', this.gulfAirFFPnumber, true);

            // Load RedeemMaster for dynamic category filter chips
            await this.reward.GetRedeemMaster(this.auth.accessToken, {}).then((redeemData: any) => {
              if (redeemData?.response?.code == 1) {
                let redeemList = redeemData?.response?.content?.list || redeemData?.response?.list || [];
                this.redeemMasterList = redeemList;
                // Build category chips from RedeemMaster — 'all' is always first, unique by category id
                let chipsMap = new Map<string, any>();
                redeemList.forEach((item: any) => {
                  if (item.category && item.partnerCode && !chipsMap.has(item.category)) {
                    chipsMap.set(item.category, {
                      id: item.category,
                      label: item.name || item.category,
                      icon: '',
                      partnerCode: item.partnerCode
                    });
                  }
                });
                this.rewardCategories = [{ id: 'all', label: 'All', icon: '', partnerCode: '' }, ...Array.from(chipsMap.values())];
              }
            });

            let body = {
              ShadowAccount: this.selectedLoyaltyCards?.shadowAccount,
              maskNumber: this.selectedLoyaltyCards?.maskedCardNumber,
              fromDate: "",
              toDate: "",
            };

            if (this.LoyaltyCards && this.LoyaltyCards.length > 0) {
              await this.reward.GetRewardsHistory(this.auth.accessToken, body).then((data: any) => {

                if (data?.response?.code == 1) {

                  // this.CommonServices.hideLoading();
                  this.HistoryData = data?.response;
                  this.PointHistory = data?.response?.content[0]?.history.forEach(item => {
                    console.log('this.groupedData[item.activityDate]', this.groupedData[item.activityDate])
                    if (!this.groupedData[item.activityDate]) {

                      this.groupedData[item.activityDate] = [];
                    }

                    this.groupedData[item.activityDate].push(item);

                  });;

                  this.uniqueMonths = Object.keys(this.groupedData);
                  console.log('uniqueMonths', this.uniqueMonths);
                  this.CommonServices.hideLoading();

                } else {

                  this.CommonServices.hideLoading();
                  this.CommonServices.ParseErrorAlert('', '', this.router, data);

                }
              })

            } else {
              this.CommonServices.hideLoading();
            }



          } else {
            this.CommonServices.hideLoading();
            this.CommonServices.ParseErrorAlert('', '', this.router, data);

          }

        })
      }
       else {
        await this.CommonServices.hideLoading();
        // this.CommonServices.ParseErrorAlert("", "", this.router, data);
      }
    }).catch((err: any) => {
      console.error('[LoyaltyPoints] loadData VerifyToken threw', err);
      this.CommonServices.hideLoading();
    }).finally(() => {
      // Reset the in-flight guard so a future navigation can re-trigger loadData
      // (the listener fires on every NavigationEnd to /LoyaltyPoints).
      this.loadDataInFlight = false;
      this.loadDataCompleted = true;
    });



  }

  showModal(num) {
    this.Redmp = true;
    this.modalObservable.next(num);
  }

  FilterbyMonth(getmonths) {
    console
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return getmonths.map(x => months[new Date(x.activityDate).getMonth()]);
  }

  /**
   * Resolves the slide index from either an owl-carousel-o event payload
   * (SlidesOutputData: { startPosition, slides }) or a plain index passed by
   * internal callers such as selectCard(0).
   */
  private resolveCardIndex(e): number {
    if (typeof e === "number") {
      return e;
    }
    if (e && typeof e.startPosition === "number") {
      return e.startPosition;
    }
    return null;
  }

  selectCard(event) {
    const index = this.resolveCardIndex(event);
    if (index == null) {
      return;
    }
    this.uniqueMonths = [];
    this.groupedData = {};

    console.log('Event', event);
    this.selectedLoyaltyCards = this.LoyaltyCards[index]
    console.log('selectedLoyaltyCards', this.selectedLoyaltyCards);
    this.reward.LoyaltyCard = this.selectedLoyaltyCards


    let PointHistory = this.HistoryData[index]?.history.forEach(item => {
      console.log('this.groupedData[item.activityDate]', this.groupedData[item.activityDate])
      if (!this.groupedData[item.activityDate]) {

        this.groupedData[item.activityDate] = [];
      }

      this.groupedData[item.activityDate].push(item);

    });;

    this.uniqueMonths = Object.keys(this.groupedData);

    this.PointHistory = PointHistory

  }
  checkamount(amount) {

    amount = amount?.split('-')

    if (amount[0] == '') {
      return 'negative'
    } else {
      return 'positive'
    }

  }
  Next123 = async (item: any) => {

    // ============================================================
    // DIAGNOSTIC LOGS — temporary, helps trace the 401 / "Unable to
    // decrypt aes key" issue. See LOYALTY_POINTS_RADEEM_401_ISSUE.md.
    // ============================================================
    console.log('[LoyaltyPoints REDEEM_NOW] CLICK', {
      itemRewardsBalance: item?.rewardsBalance,
      detailuserCached: !!this.auth.detailuser,
      accessTokenLength: this.auth.accessToken?.length,
      accessTokenPrefix: this.auth.accessToken?.substring(0, 12),
    });

    console.log("1234", item);
    this.maxSliderValues=item?.rewardsBalance;
    console.log("maxSliderValues", this.maxSliderValues);

    this.cookieService.set("maxSlider",this.maxSliderValues,true);
    // Validate the token here, before navigating, so the redeem page's ngOnInit
    // can call GetRedeemMaster with a freshly-rotated token. Matches the pattern
    // other pages use to avoid the encryption race on back-to-back API calls.
    this.CommonServices.presentLoading();
    this.auth.accessToken = await this.CommonServices.Get("token");
    console.log('[LoyaltyPoints REDEEM_NOW] → VerifyToken (pre-nav)', {
      tokenLength: this.auth.accessToken?.length,
      tokenPrefix: this.auth.accessToken?.substring(0, 12),
    });
    this.auth.VerifyToken({}, this.auth.accessToken).then((data: any) => {
      console.log('[LoyaltyPoints REDEEM_NOW] ← VerifyToken response', data);
      this.CommonServices.hideLoading();
      if (data?.response?.code == 1) {
        console.log('[LoyaltyPoints REDEEM_NOW] VerifyToken OK → navigating to /LoyaltyPointsRadeem', {
          tokenLength: this.auth.accessToken?.length,
          tokenPrefix: this.auth.accessToken?.substring(0, 12),
        });
        this.router.navigateByUrl('LoyaltyPointsRadeem');
      } else {
        console.warn('[LoyaltyPoints REDEEM_NOW] VerifyToken failed', data);
        this.CommonServices.ParseErrorAlert("", "", this.router, data);
      }
    }).catch((err: any) => {
      console.error('[LoyaltyPoints REDEEM_NOW] VerifyToken promise rejected', err);
      this.CommonServices.hideLoading();
    });

  }
  Next(item) {


    this.cookieService.set("Gulfnumber", this.selectedLoyaltyCards?.gulfAirMembership,true);
    this.cookieService.set("rewardBalance", this.selectedLoyaltyCards?.rewardsBalance, true);
    this.cookieService.set("shukranNo", this.selectedLoyaltyCards?.shukranNo, true);

    this.showModal(2);

    // this.router.navigateByUrl('LoyaltyPointsRadeem');

  }

  loyaltyPointsRadeem() {

    
    this.router.navigateByUrl('LoyaltyPointsRadeem');
  }

  test(val) {

    console.log(val)
    this.selectedMonth = this.Months.filter(x => x.Mon == val);

    console.log("selectedMonth", this.selectedMonth);
    this.lastday = new Date(this.CurrentYear, this.selectedMonth[0].Num, 0);
    console.log(this.lastday.toString(), "LastDay");
    console.log(this.datepipe.transform(this.lastday, "dd/MM/YYYY"), "LastDay");



  }

  FilterDone() {
    this.CommonServices.presentLoading();

    this.uniqueMonths = [];
    this.groupedData = {};

    let body = {
      ShadowAccount: this.selectedLoyaltyCards?.shadowAccount,
      maskNumber: this.selectedLoyaltyCards?.maskedCardNumber,
      fromDate: "01/" + this.selectedMonth[0].Num + "/" + this.CurrentYear,
      toDate: this.datepipe.transform(this.lastday, "dd/MM/yyyy")
    };
    this.reward.GetRewardsHistory(this.auth.accessToken, body).then((data: any) => {

      if (data?.response?.code == 1) {

        this.HistoryData = data?.response;

        console.log("GetRewardsHistory", this.HistoryData)
        this.PointHistory = data?.response?.content[0]?.history.forEach(item => {

          console.log('this.groupedData[item.activityDate]', this.groupedData[item.activityDate])

          if (!this.groupedData[item.activityDate]) {

            this.groupedData[item.activityDate] = [];
          }

          this.groupedData[item.activityDate].push(item);

        });;

        this.uniqueMonths = Object.keys(this.groupedData);

        console.log('uniqueMonths', this.uniqueMonths);
        this.CommonServices.hideLoading();

      } else {

        this.CommonServices.hideLoading();
        this.CommonServices.ParseErrorAlert('', '', this.router, data);

      }





    })
  }

  onRedemptionChange(event, e) {
    console.log("event", event)
    this.selectevent = event;
    if (e == 1 || e == 2 || e == 3) {
      this.Redmp = false
      this.activeTab = e;
    }
  }

  cancel() {
    this.selectevent.srcElement.checked = false;
  }

  // Category filter
  filterByCategory(categoryId: string): void {
    this.selectedCategory = categoryId;
  }

  // Check if current filter has any items across all months
  hasFilteredItems(): boolean {
    if (this.selectedCategory === 'all') return true;
    const allItems = Object.values(this.groupedData || {}).flat();
    return this.getFilteredItems(allItems).length > 0;
  }

  getSelectedCategoryLabel(): string {
    const cat = this.rewardCategories.find(c => c.id === this.selectedCategory);
    return cat ? cat.label : '';
  }

  // Filter items by selected category (partnerCode match via RedeemMaster, fallback to activityType)
  getFilteredItems(items: any[]): any[] {
    if (!items) return [];
    if (this.selectedCategory === 'all') return items;
    const cat = this.rewardCategories.find(c => c.id === this.selectedCategory);
    if (!cat || !cat.partnerCode) return items;
    return items.filter(item => {
      const partner = (item?.partnerNumber || '').toUpperCase();
      const activity = (item?.activityType || '').toLowerCase();
      const effectivePartner = partner || this.derivePartnerCodeFromActivity(activity);
      return effectivePartner === cat.partnerCode.toUpperCase();
    });
  }

  // Derive partnerCode from activityType when partnerNumber is empty
  derivePartnerCodeFromActivity(activity: string): string {
    if (activity.includes('cashback')) return 'CASHBACK';
    if (activity.includes('gulf') || activity.includes('air')) return 'GULF_AIR_FFP';
    if (activity.includes('shukran')) return 'SHUKRAN';
    if (activity.includes('jawaher')) return 'JAWAHER';
    if (activity.includes('etihad')) return 'ETIHAD';
    if (activity.includes('qatar')) return 'QATAR';
    if (activity.includes('zakat') || activity.includes('sadaqat')) return 'ZAKAT';
    if (activity.includes('royal humanitarian') || activity.includes('rhf')) return 'RHF';
    return '';
  }

  // P/Y/N status badge class — empty status (e.g. "Points earned") shows no badge
  getStatusBadgeClass(status: string): string {
    const s = (status || '').toUpperCase();
    if (!s) return ''; // empty status = no badge
    switch (s) {
      case 'Y': return 'badge-completed';
      case 'P': return 'badge-pending';
      case 'N': return 'badge-rejected';
      default: return '';
    }
  }

  // Map status code to translation key
  getStatusLabel(status: string): string {
    const s = (status || '').toUpperCase();
    if (!s) return ''; // empty status = no label
    switch (s) {
      case 'Y': return 'LoyaltyAvailable';
      case 'P': return 'LoyaltyPending';
      case 'N': return 'LoyaltyRejected';
      default: return '';
    }
  }

  // Get partner icon for history items
  getHistoryPartnerIcon(item: any): string {
    const partner = (item?.partnerNumber || '').toUpperCase();
    const activity = (item?.activityType || '').toLowerCase();
    if (partner.includes('CASHBACK') || activity.includes('cashback')) return 'icon-cash-back';
    if (partner.includes('GULF') || activity.includes('gulf')) return 'icon-gulf-air';
    if (partner.includes('SHUKRAN') || activity.includes('shukran')) return 'icon-shukran';
    if (partner.includes('JAWAHER') || activity.includes('jawaher')) return 'icon-jawaher';
    if (partner.includes('ETIHAD') || activity.includes('etihad')) return 'icon-etihad';
    if (partner.includes('QATAR') || activity.includes('qatar')) return 'icon-qatar';
    if (partner.includes('ZAKAT') || partner.includes('RHF') || activity.includes('zakat') || activity.includes('sadaqat') || activity.includes('royal humanitarian')) return 'icon-giveback';
    return 'icon-giveback';
  }

  onCalcCardChange(cardInternalId: string): void {
    this.selectedCalcCardInternalId = cardInternalId;
    this.calcLocalSpend = 0;
    this.calcIntlSpend = 0;
    this.calcGovPetrol = 0;
    this.calcEurGbp = 0;
    this.calcResult = null;
  }

  async calculatePoints(): Promise<void> {
    const total = this.calcLocalSpend + this.calcIntlSpend + this.calcGovPetrol + this.calcEurGbp;
    if (total <= 0) {
      this.calcResult = null;
      return;
    }
    try {
      const body: any = {
        requestHeader: {
          serviceUserID: 'MobileBanking',
          servicePassword: '123456789',
          requestId: '',
          userSessionId: '',
          channelId: 'MB'
        },
        requestBody: {
          key: this.selectedCalcCardInternalId || this.selectedLoyaltyCards?.cardInternalId || '',
          BaseClass: { id: '', bankId: '' }
        }
      };
      const rb = body.requestBody;
      rb.local_spend = this.calcLocalSpend?.toString() || '0';
      rb.international_spend = this.calcIntlSpend?.toString() || '0';
      rb.gov_petrol_station = this.calcGovPetrol?.toString() || '0';
      rb.physical_EUR_GBP = this.calcEurGbp?.toString() || '0';
      const data: any = await this.reward.LoyaltyPointsCalculator(this.auth.accessToken, body);
      console.log('Calculator response:', JSON.stringify(data));
      if (data?.response?.code == 1) {
        // Try responseBody -> Result -> content directly
        let result = data.response.content?.responseBody || data.response.content?.Result || data.response.content;
        // If result is a JSON string, parse it
        if (typeof result === 'string') {
          try { result = JSON.parse(result); } catch(e) {}
        }
        this.calcResult = result;
      } else {
        this.calcResult = null;
      }
    } catch (e) {
      console.error('Calculator error', e);
      this.calcResult = null;
    }
  }

}
